import React, { PureComponent } from 'react';
import { Div } from 'Common/components/Atoms/Div';
import { Flex } from 'Common/components/Atoms/Flex';
import { PageContainer } from 'Common/components/Templates/PageContainer';
import { Text } from 'Common/components/Atoms/Text';
import Stepper from './Stepper';
import TwoFactorAuth from '../../containers/ReviewerOnboarding/TwoFactorAuth';
import SlackConnect from '../../containers/ReviewerOnboarding/SlackConnect';
import Settings from '../../containers/ReviewerOnboarding/Settings';
import Success from './Success';
import { ApplicationSubmittedStep } from '../../containers/ReviewerOnboarding/ApplicationSubmittedStep';
import ReviewerDashboard from '../ReviewerDashboard';
import { Theme } from '@mui/material/styles';
import withTheme from '@mui/styles/withTheme';
import { Redirect } from 'react-router-dom';
import { User } from '../../models/User';

interface Props {
  theme: Theme;
  user: User;
}

interface State {
  step: number;
}

class ReviewerOnboarding extends PureComponent<Props, State> {
  state = {
    step: 0,
  };

  handleSubmit = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 });
  };

  renderOnboarding(): JSX.Element {
    const { theme, user } = this.props;
    const { step } = this.state;

    if (step === 3) {
      return <Success user={user} />;
    }

    return (
      <Flex height="100%">
        <Flex
          width={240}
          borderRight={`solid 1px ${theme.palette.divider}`}
          justifyContent="center"
          alignItems="flex-start"
        >
          <Stepper step={step} />
        </Flex>
        <Flex flexGrow={1} style={{ overflowY: 'auto' }}>
          <PageContainer height="100%" width="100%">
            <Text variant="h2" mb={3}>
              Congratulations! You've been accepted as a PullRequest reviewer.
            </Text>
            <Text variant="body1">
              Before you get started reviewing code, you'll need to complete a
              few final steps.
            </Text>
            <Div mt={6}>
              {step === 0 && <TwoFactorAuth handleSubmit={this.handleSubmit} />}
              {step === 1 && <SlackConnect handleSubmit={this.handleSubmit} />}
              {step === 2 && <Settings handleSubmit={this.handleSubmit} />}
            </Div>
          </PageContainer>
        </Flex>
      </Flex>
    );
  }

  render(): JSX.Element {
    const { user } = this.props;
    if (!user || !user.reviewer_profile || !user.is_reviewer) {
      return <Redirect to="/signups/reviewer" />;
    }

    const { reviewer_profile } = user;
    if (!reviewer_profile.has_been_screened) {
      return <ApplicationSubmittedStep name={user?.name} />;
    }

    if (reviewer_profile.is_onboarded) {
      return <ReviewerDashboard user={user} />;
    }

    return this.renderOnboarding();
  }
}

export default withTheme(ReviewerOnboarding);
